import { serviceProvider } from '@yola/subscription-manager-js';
import { errors } from '@yola/ws-sdk';
import user from 'yola-editor/src/js/modules/user';
import fetchAvailablePackagesComplete from '../actions/fetch-available-packages-complete';

const fetchAvailablePackages = () => async (dispatch, getState) => {
  const state = getState();
  const partnerData = user.selectors.getPartnerData(state);
  const { id: partnerId } = partnerData;

  try {
    await serviceProvider.fetchPackages(partnerId);
    dispatch(fetchAvailablePackagesComplete());
  } catch (error) {
    errors.operations.catchError(error);
  }
};

export default fetchAvailablePackages;
